import type { BalanceResponse } from "@loot-os/client";

/**
 * What the shopper can spend right now: `balanceCents` net of `heldCents`, the price of an
 * unclaimed box open. Every balance the storefront shows is this number, so an open costs its
 * price at the reveal and the claim leaves the shown balance where it is. A battle seat holds
 * nothing: its entry is debited from `balanceCents` the moment the seat is taken.
 */
export function spendableCents(balance: Pick<BalanceResponse, "balanceCents" | "heldCents">) {
  return balance.balanceCents - balance.heldCents;
}
